<template>
  <div
    :style="cssVariables"
    :class="gradient ? 'bg-gradient' : null"
    class="p-3 mb-2 bg-primary text-white rounded"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    gradient: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rgbStart: '25, 64, 98',
      opacityStart: 1,
      rgbEnd: '104, 121, 147',
      opacityEnd: 0.5,
    }
  },
  computed: {
    cssVariables() {
      return {
        '--rgb-start': this.rgbStart,
        '--opacity-start': this.opacityStart,
        '--rgb-end': this.rgbEnd,
        '--opacity-end': this.opacityEnd,
        '--percent': this.gradient ? this.gradient + '%' : 100 + '%',
      }
    },
  },
}
</script>
/*
<style scoped>
.bg-gradient {
  --bs-gradient: linear-gradient(
    80deg,
    rgba(var(--rgb-start), var(--opacity-start)) var(--percent),
    rgba(var(--rgb-end), var(--opacity-end))
  );
}
</style>
